<template>
  <p v-if="!logo" class="bg-gray-200 rounded w-32 h-8 p-3 animate-pulse">{{ "" }}</p>
  <img
    v-else
    id="logo"
    :src="logo ?? image"
    @click="go.redirectToPage('home')"
    alt="logo"
  />
</template>

<script lang="ts">
import { useThemeStore } from "@/store/theme";
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "logo",
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  props: {
    image: {
      type: String,
      default: "/images/logo.svg",
    },
  },
  setup() {
    const storeTheme = useThemeStore;
    const logo = ref(storeTheme.logo);
    watch(storeTheme, (val) => (logo.value = val.logo));

    return { logo, storeTheme };
  },
});
</script>

<style lang="scss">
#logo {
  @apply flex justify-center w-fit h-[2.5rem] #{!important};
}
</style>
